<template>
  <nav class="">
    <ul v-if="hasNav" class="space-y-4 text-gray-600">
      <li v-for="item in pageNavItems" :key="item.display" @click="handleClick">
        <router-link
          :to="{ name: item.pathName }"
          class="block p-2 text-gray-700"
          >
            {{ item.display }}
            <m-badge
              v-if="item.new"
              type="GREEN"
            >
              New
            </m-badge>
        </router-link>
      </li>
    </ul>
    <hr class="mt-6" v-if="hasNav" />
    <tbc-calculator />
    <feedback-link />
  </nav>
</template>

<script>
import { childRoutes as accountChildRoutes } from '@/app/router/routes/modules/account';
import FeedbackLink from '@/app/modules/_shared/layout/sidebar/components/feedback-link/feedback-link.vue';
import TbcCalculator from '@/app/modules/_shared/layout/sidebar/components/tbc-calculator/tbc-calculator.vue';

export default {
  components: {
    FeedbackLink,
    TbcCalculator,
  },
  name: 'nav-menu',
  computed: {
    activeApp() {
      return this.$store.getters['app/activeApp'];
    },
    hasNav() {
      return this.activeApp && this.activeApp.appName !== 'HOME';
    },
    pageNavItems() {
      if (this.activeApp && this.activeApp.appName === 'ACCOUNT_MANAGEMENT') {
        const routes = accountChildRoutes.filter((route) => {
          const hasPermission = route.meta && route.meta.permission
            ? this.activeApp.permission === route.meta.permission
            : true;
          return !['subscribe', 'account-details', 'account-courses'].includes(route.name) && hasPermission;
        });

        return routes.map(route => ({
          display: route.meta.display,
          pathName: route.name,
          new: route.meta.new,
        }));
      }

      if (this.activeApp && this.activeApp.appName === 'TOOLKIT') {
        const items = [
          {
            display: 'Investment Strategy',
            pathName: 'inv-strat-dashboard',
            new: false,
          },
          {
            display: 'Investment Strategy Review',
            pathName: 'inv-strat-review-dashboard',
            new: false,
          },
        ];

        const PSU = {
          display: 'Pension Establishment',
          pathName: 'pension-establishment-dashboard',
          new: false,
        };

        const OELS = {
          display: 'Prospective Benefit Payment Instruction',
          pathName: 'pension-payment-instruction-dashboard',
          new: false,
        };

        if (
          process.env.VUE_APP_TOOLKIT_FEATURES.includes('PENSION_ESTABLISHMENT')
        ) {
          items.push(PSU);
          items.push(OELS);
        }

        return items;
      }
      return [];
    },
  },
  methods: {
    handleClick() {
      this.$emit('nav-change');
    },
  },
};
</script>

<style scoped>
.router-link-exact-active {
  @apply bg-blue-100 rounded text-blue-800 font-bold;
}
</style>
